import loadable from '@loadable/component';

export const WhSiteWrapper = loadable(
  () => import(/* webpackChunkName: "wh-site" */ './WhSiteWrapper'),
);
